module.exports = __webpack_public_path__ + "assets/happy-flatfy.bd1f0f40.svg";